import React from 'react';
import { useHtmlDocument } from '../../../hooks/html-document';
import { AppSystemCovidRegistration } from './covid-registration/AppSystemCovidRegistration';
import { useMeta } from '../../../hooks/meta';
import { useDiscount } from '../../../hooks/discount';

export function AppSystem() {
    useHtmlDocument().useRegister();
    useMeta().useRegister();
    useDiscount().useRegister();

    return (
        <>
            <AppSystemCovidRegistration />
        </>
    );
}
